'use strict';

function NotFoundError(message) {
  this.name = 'Not found';
  this.message = message || 'Not found';
  this.status = 404;
}

NotFoundError.prototype = Error.prototype;

module.exports = NotFoundError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/errors/notFoundError.js
 ** module id = 232
 ** module chunks = 0
 **/